module.exports = __webpack_public_path__ + "img/safari.2a116a26.png";